package com.speedsoftware.nibbler.ui.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.speedsoftware.nibbler.qr.QrCode

/** Draws [text] as a QR code: black modules on a white tile with the 4-module quiet zone scanners need. */
@Composable
fun QrCodeImage(text: String, modifier: Modifier = Modifier, size: Dp = 200.dp) {
    val qr = remember(text) { QrCode.encodeText(text) }
    Canvas(modifier = modifier.size(size).background(Color.White)) {
        val quietZone = 4
        val cell = this.size.minDimension / (qr.size + quietZone * 2)
        for (y in 0 until qr.size) for (x in 0 until qr.size) {
            if (qr.isDark(x, y)) {
                drawRect(
                    color = Color.Black,
                    topLeft = Offset((x + quietZone) * cell, (y + quietZone) * cell),
                    size = Size(cell + 0.5f, cell + 0.5f) // tiny overlap avoids hairline gaps between modules
                )
            }
        }
    }
}

@androidx.compose.ui.tooling.preview.Preview
@Composable
private fun QrCodeImagePreview() {
    QrCodeImage(text = "otpauth://totp/Nibbler:me%40example.com?secret=GEZDGNBVGY3TQOJQ&issuer=Nibbler")
}
